/** @file Error codes every package throws through `Pose3DError` (values equal their keys). */

/**
 * Error codes; `REF_ANGLES_LENGTH` of the W0 plan is `DRAWN_ANGLES_LENGTH` (design 15.4). The server and client
 * codes (`AUTH` .. `TRANSPORT`, ruling R6) are thrown by `server`, `api` and `cli`, never by a document validator.
 */
export const ERROR_CODES = {
  VALIDATION: 'VALIDATION',
  NODE_PARENT_UNKNOWN: 'NODE_PARENT_UNKNOWN',
  NODE_CYCLE: 'NODE_CYCLE',
  NODE_ROOT_COUNT: 'NODE_ROOT_COUNT',
  NODE_MIRROR_UNKNOWN: 'NODE_MIRROR_UNKNOWN',
  NODE_DUPLICATE_MIRROR: 'NODE_DUPLICATE_MIRROR',
  SOCKET_NODE_UNKNOWN: 'SOCKET_NODE_UNKNOWN',
  ATTACHMENT_REF_UNKNOWN: 'ATTACHMENT_REF_UNKNOWN',
  DRAWABLE_NODE_UNKNOWN: 'DRAWABLE_NODE_UNKNOWN',
  DRAWABLE_DUPLICATE_ID: 'DRAWABLE_DUPLICATE_ID',
  SHEET_UNKNOWN: 'SHEET_UNKNOWN',
  VARIANT_UNKNOWN: 'VARIANT_UNKNOWN',
  SECTOR_TABLE_UNKNOWN: 'SECTOR_TABLE_UNKNOWN',
  SECTOR_TABLE_SHAPE: 'SECTOR_TABLE_SHAPE',
  DRAWN_ANGLES_LENGTH: 'DRAWN_ANGLES_LENGTH',
  PROFILE_UNKNOWN: 'PROFILE_UNKNOWN',
  FRAME_OUT_OF_RANGE: 'FRAME_OUT_OF_RANGE',
  KEY_ORDER: 'KEY_ORDER',
  NOT_FOUND: 'NOT_FOUND',
  STALE_REV: 'STALE_REV',
  REDO_STALE: 'REDO_STALE',
  CONFLICT: 'CONFLICT',
  NAME_TAKEN: 'NAME_TAKEN',
  NOT_TRASHED: 'NOT_TRASHED',
  AUTH: 'AUTH',
  FORBIDDEN: 'FORBIDDEN',
  ORIGIN: 'ORIGIN',
  RATE_LIMITED: 'RATE_LIMITED',
  TRANSPORT: 'TRANSPORT',
  LIMIT: 'LIMIT',
  INTERNAL: 'INTERNAL',
} as const;

/** One error code. */
export type ErrorCode = keyof typeof ERROR_CODES;
